import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoTermsAction, 
  setIsFetching, 
  setFetchFailed, 
  setTermsContent,
} from 'Pages/InfoTermsPage/Redux/actions';

export const fetchTermsContent = () => {
  return async (dispatch: Dispatch<InfoTermsAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoTerms;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('TermsPage');

      if (response.status === 200) {
        const newContent: Julius.Website.TermsPageViewModel = await response.json();
        dispatch(setTermsContent(newContent));
      } else {
        dispatch(setFetchFailed());
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/pages/InfoTermsPage/Redux/thunks.tsx